import styles from './styles.module.css';
import { useState } from 'react';
/**
 *
 * @param {*} props [
 * 	stylesIcon = styles para aplicar na tag img dentro do button
 * 	srcIcon = url img do icon
 * 	svgTag = tag svg da imagem, inutiliza o srcIcon
 * 	iconPosition = left|right - relacionado ao children: antes ou depois : default right
 * ]
 * @returns
 */
const ButtonIcon = (props) => {
  const {
    children,
    iconWidth,
    iconHeight,
    stylesIcon,
    srcIcon,
    iconPosition,
    className,
    svgTag,
    wl,
    bgded, // (true:false) se for button preenchido com a cor de tema
    onFocus,
    onBlur,
    onMouseOver,
    onMouseLeave,
    color,
    hoverColor,
    ...restProps
  } = props;

  const [styleFocus, setStyleFocus] = useState({});

  const marginIcon =
    iconPosition == 'left'
      ? {
          marginRight: '8px',
        }
      : {
          marginLeft: '8px',
        };
  const iconSetWidth = iconWidth ? iconWidth : '16px';
  const iconSetHeight = iconHeight ? iconHeight : '16px';
  const icon = (
    <div
      className={styles.img}
      style={{
        marginTop: 'auto',
        marginBottom: 'auto',
        maxHeight: `${iconSetHeight}!important`,
        maxWidth: `${iconSetWidth}!important`,
        ...marginIcon,
      }}
    >
      {!!svgTag ? (
        svgTag
      ) : srcIcon ? (
        <img
          style={{
            maxHeight: `${iconSetHeight}!important`,
            maxWidth: `${iconSetWidth}!important`,
            stylesIcon,
          }}
          src={srcIcon}
          className={styles.img}
          alt=""
        />
      ) : (
        ''
      )}
    </div>
  );

  const focus = (event) => {
    if (onFocus) {
      onFocus(event);
    }
    setStyleFocus({
      border: `1px ${wl.cor_tema_4} solid`,
      backgroundColor: wl.cor_tema_4,
      boxShadow: `0 0 0.5rem ${wl.cor_tema_4}`,
      outline: 0,
    });
  };

  const blur = (event) => {
    if (onBlur) {
      onBlur(event);
    }

    setStyleFocus({
      border: `1px ${color ? color : wl?.cor_tema_secundaria} solid`,
    });
  };

  const hover = (event) => {
    if (onMouseOver) {
      onMouseOver(event);
    }

  };

  return (
    <span className={styles.spanButton}>
      <button
        style={{
          border: className?.includes('selected')
            ? color
              ? color
              : wl?.cor_tema_secundaria
            : `1px ${color ? color : wl?.cor_tema_secundaria} solid`,
          color: `${
            bgded ? wl.cor_texto_botao : color ? color : wl?.cor_tema_secundaria
          }`,
          backgroundColor: className?.includes('selected')
            ? wl?.cor_tema_4
            : `${bgded ? wl?.cor_tema_secundaria : ''}`,
          ...styleFocus,
        }}
        onFocus={focus}
        onBlur={blur}
        onMouseOver={hover}
        // onMouseLeave={leave}
        className={`${styles.button} ${className}`}
        {...restProps}
      >
        {iconPosition == 'left' ? icon : ''}
        {children}
        {iconPosition != 'left' ? icon : ''}
      </button>
    </span>
  );
};

export default ButtonIcon;
